import {Component, Input, OnInit} from "@angular/core";
import {Platform} from "ionic-angular";
import {VideoService} from "./video.service";

declare var window: any;

@Component({
  selector: 'app-video-link',
  template: `
    <button ion-button block large icon-left color="favorite" 
            (click)="joinCall()" 
            [attr.disabled]="loading ? true : null">
      <ion-icon name="videocam"></ion-icon>
      {{ (!loading ? 'job.join_call' : 'Loading...')  | translate }}
    </button>
  `,
})
export class VideoLinkComponent implements OnInit {
  loading = false;
  @Input('jobId') jobId;

  ngOnInit(): void {
  }

  constructor(private videoService: VideoService,
              private platform: Platform) {
  }

  joinCall(){
    this.loading = true;
    this.platform.ready().then(() => {
      this.videoService.getLink(this.jobId)

        .finally(() => this.loading = false)

        .subscribe(res => {
          if(this.platform.is('cordova')){
            return this.startMeetingInApp(res);
          }
          this.openMeetingInBrowser(res.link);
        })
    });
  }

  private startMeetingInApp(res){
    this.videoService.setMeetingState({
      sessionId: res.precallSessionId,
      token: res.token,
      apiKey: res.apiKey
    });
  }

  private openMeetingInBrowser(link){
    // This might need to be implemented as a native "a" element because of popup blocking
    window.open(link, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/video/video-link.component.ts